import { Box, Flex, Modal } from '@zoomit/primitives';
import { isMobile } from '@zoomit/web-kit';
import { Button, cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import Logout from '../../assets/svg/logout.svg';

type Props = {
  onClose(): void;
  isLoading: boolean;
  mutate(): void;
};

const LogoutModalComponent = (props: Props) => {
  const { onClose, mutate, isLoading } = props;

  return (
    <Flex
      justifyContent="center"
      style={{ height: '100%' }}
      alignItems="center"
      flexDirection="column"
      gap={4}
    >
      <Logout />
      <Flex alignItems="center" flexDirection="column" gap={2}>
        <Typography variant="h5" textColor={cssVar(theme.black3)}>
          خروج از حساب کاربری
        </Typography>
        <Typography variant="callout" textColor={cssVar(theme.black3)}>
          آیا می‌خواهید از حساب کاربری خود خارج شوید؟
        </Typography>
      </Flex>
      <Flex gap={1.6}>
        <Button onClick={mutate} isLoading={isLoading} type="submit" color={cssVar(theme.black3)}>
          بله خارج می‌شوم
        </Button>
        <Button variant="outline" disabled={isLoading} onClick={onClose}>
          انصراف
        </Button>
      </Flex>
    </Flex>
  );
};

const LogoutModal = (props: Props) => {
  const { isLoading } = props;

  const onClose = () => {
    if (isLoading) return;
    props.onClose();
  };

  if (isMobile) {
    return (
      <Box
        className={'fixed top-0 left-0 z-10 h-full w-full'}
        spacing={{ py: 'x12' }}
        backgroundColor={cssVar(theme.background1)}
      >
        <LogoutModalComponent {...props} />
      </Box>
    );
  }

  return (
    <Modal onClose={onClose}>
      <Box spacing={{ py: 'x12' }} backgroundColor={cssVar(theme.background1)}>
        <LogoutModalComponent {...props} />
      </Box>
    </Modal>
  );
};

export default LogoutModal;
